export default Object.freeze({
  // MEMBER_EXPEL_
  TITLE: '탈퇴회원 조회',
  DESCRIPTION: '간편로그인 회원은 탈퇴 철회 및 재가입 불가/해제 처리를 할 수 없습니다.',
  SEARCH_FIELD_DATE: '탈퇴일자',
  REJOINABILITY: '재가입 여부',
  REJOINABILITY_YES: '가능',
  REJOINABILITY_NO: '불가',

  LIST_ITEM_MEMBER_GROUP: '회원그룹',
  LIST_ITEM_WITHDRAW_REASON: '탈퇴사유',
  LIST_ITEM_FORCED: '강제탈퇴',
  LIST_ITEM_WITHDRAW_DATE: '탈퇴일',
  LIST_ITEM_REJOINABILITY: '재가입',

  BTN_RESTORE_EXPELLED: '탈퇴 철회',
  BTN_REJOIN_DISABLE: '재가입 불가',
  BTN_REJOIN_ENABLE: '재가입 불가해제',

  NOT_SELECTED: '회원을 선택하세요.',
  ALERT_RESTORE_RESTORE_EXPELLED: '간편로그인 회원은 탈퇴 취소가 불가능합니다.',
  ALERT_RESTORE_REJOIN_DISABLE: '간편로그인 회원은 재가입 불가 처리할 수 없습니다.',
  ALERT_RESTORE_REJOIN_ENABLE: '간편로그인 회원은 재가입 불가 해제 처리할 수 없습니다.',
  CONFIRM_RESTORE_EXPELLED: '선택하신 회원의 탈퇴를 철회 하시겠습니까? 회원정보가 복구됩니다.',
  CONFIRM_REJOIN_DISABLE: '선택하신 회원의 재가입 불가처리를 하시겠습니까?\n(재가입 불가해제 처리는 탈퇴 후 7일 이내에만 가능)',
  CONFIRM_REJOIN_ENABLE: '선택하신 회원의 재가입 불가를 해제 하시겠습니까?',

  RESTORE_SUCCESS_MSG: '성공{0}건: 탈퇴철회 완료\r',
  REJOIN_DISABLE_SUCCESS_MSG: '성공{0}건: 재가입 불가 완료\r',
  REJOIN_ENABLE_SUCCESS_MSG: '성공{0}건: 재가입 불가 해제 완료\r',
  FAIL_MSG: '실패{0}건: {1}',

  POPUP_TITLE: '회원 강제탈퇴',
  REJOINABILITY_WHETHER_YES: '재가입 가능',
  REASON: '강제탈퇴 사유',
  REASON_EMAIL: 'e메일',
  REASON_SMS: 'SMS',
  REASON_SEND_ALL: '모두 발송',
  REASON_INPUT: '강제탈퇴 사유 입력',
  ALERT_REASON_INPUT_EMPTY: '강제탈퇴 사유를 입력하세요.',
  NOTICE: '강제탈퇴 알림',
  NOTICE_CONTENT: '고객알림 내용',
  ALERT_NOTICE_CONTENT_EMPTY: '고객알림 내용을 입력하세요.',
  NOTICE_CONTENT_INPUT: '고객알림 내용 입력',
  CONFIRM_TEXT: '강제탈퇴를 진행하시겠습니까?',
  SUCCESS_MESSAGE: '성공%d 건: 강제탈퇴 완료'
});
